import { getYearsFromDate } from "./utils/getYearsFromDate.";

const bio = `Software Engineer with ${getYearsFromDate(
  new Date("2021-03-08"),
)} years of experience and skilled in JavaScript, TypeScript, Node.js, and various frameworks including React and Next.js. Proficient in cloud services such as AWS and Docker.

Passionate about developing scalable and efficient web and mobile applications. Proven ability in leading projects, optimizing backend solutions, and mentoring junior developers.

Let's connect!`;

const config = {
  name: "jayant dhawan",
  profile: "full stack developer",
  image: "",
  social: {
    github: "https://github.com/jayant-dhawan",
    linkedin: "https://linkedin.com/in/jayant-dhawan",
    mail: "jayantdhawan95@gmail.com",
    twitter: "https://twitter.com/jayant_dhawan",
  },
  bio,
  experiences: [
    {
      company: "Codinova Technologies",
      position: "Software Developer",
      startDate: "March 2021",
      isCurrent: true,
    },
    {
      company: "AdsXenium Technology",
      position: "Software Developer Intern",
      startDate: "January 2020",
      endDate: "August 2020",
    },
  ],
  resumeLink:
    "https://drive.google.com/file/d/1xuOZi3vhjr6TW05jpu4fKerB60vrsz9d/view",
  skills: [
    {
      icon: "https://img.icons8.com/color/96/null/javascript--v1.png",
      name: "JavaScript",
    },
    {
      icon: "https://img.icons8.com/color/96/null/typescript.png",
      name: "TypeScript",
    },
    {
      icon: "https://img.icons8.com/color/96/null/react-native.png",
      name: "React",
    },
    {
      icon: "https://img.icons8.com/color/96/null/nextjs.png",
      name: "NextJs",
    },
    {
      icon: "https://img.icons8.com/color/96/null/nodejs.png",
      name: "NodeJS",
    },
    {
      icon: "https://img.icons8.com/color/96/null/graphql.png",
      name: "GraphQL",
    },
    {
      icon: "https://img.icons8.com/color/96/null/mysql.png",
      name: "MySQL",
    },
    {
      icon: "https://img.icons8.com/color/96/null/mongodb.png",
      name: "MongoDB",
    },
    {
      icon: "https://img.icons8.com/color/96/null/html-5--v1.png",
      name: "HTML",
    },
    {
      icon: "https://img.icons8.com/color/96/null/css3.png",
      name: "CSS",
    },
    {
      icon: "https://img.icons8.com/color/96/null/react-native.png",
      name: "React Native",
    },
    {
      icon: "https://img.icons8.com/color/96/null/git.png",
      name: "GIT",
    },
    {
      icon: "https://img.icons8.com/color/96/null/amazon-web-services.png",
      name: "AWS",
    },
  ],
};

// Picked up icons for skill from here: https://icons8.com/icon/set/logos/color
// Trick: "https://img.icons8.com/color/96/null/<skill-name>.png"

export default config;
